import { Component, OnInit, Input } from '@angular/core';


@Component({
    selector: 'sample-search',
    templateUrl: './sample-search.component.html',
    styleUrls: [ './sample-search.component.scss' ]
})
export class SampleSearchComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}
